
import { method } from 'lodash';
import Auth, { FetchAPI, ParamsSerializer, Mutex } from './auth-service';
const instanceGroupFields = [
  {
    variable: "instance_name",
    headerName: "Instance Name",
    hidden: false,
    field: "instance_name",
  },
  {
    variable: "instances",
    headerName: "Instances",
    hidden: false,
    field: "instances",
  },
  {
    variable: "template",
    headerName: "Template",
    hidden: false,
    field: "template",
  },
  {
    variable: "group_type",
    headerName: "Group Type",
    hidden: false,
    field: "group_type",
  },
  {
    variable: "zone",
    headerName: "Zone",
    hidden: false,
    field: "zone",
  },
  {
    variable: "autoscaling",
    headerName: "Autoscaling",
    hidden: false,
    field: "autoscaling",
  },
  {
    variable: "status",
    headerName: "Status",
    hidden: false,
    field: "status",
  },
];

class GCPDataService {
  constructor() {
    // we only need one of these
    if (!GCPDataService.instance) {
      GCPDataService.instance = this;
      this.catMux = new Mutex();
    }
    this.searchPlaceholder = "Search Instance group";
    this.regions = new Map();
    this.networks = new Map();

    //Credentials
    this.uploadKeyFile = (content) => {
      const a = Auth.getAuth();
      const form = new FormData();
      form.append('fileblob', content);

      return fetch('/api/system/gcp/-keyfile', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${a.token}`,
        },
        body: form,
      }).then((res) => {
        return res;
      }).catch(response => {
        if ([401, 403].indexOf(response.status) !== -1) {
          return Auth.boot();
        }
      });
    };


    this.deleteGCPCreds = () => {
      return FetchAPI({
        url: 'system/gcp/-keyfile',
        method: 'DELETE',
      }).then((res) => {
        return 200;
      });
    };

    this.getConfig = () => {
      return FetchAPI({
        url: 'system/gcp',
        method: 'GET',
      });
    };


    //Global
    this.getNetwork = () => {
      return FetchAPI({
        url: 'system/gcp/networks',
        method: 'GET',
      });
    };

    //sharedNetworks
    this.getSharedNetwork = (project) => {
      return FetchAPI({
        url: `system/gcp/sharednetworks/${project}`,
        method: 'GET',
      })
    }

    this.getXPNhosts = () => {
      return FetchAPI({
        url: 'system/gcp/xpnhosts',
        method: 'GET',
      });
    };

    this.getRegions = () => {
      return FetchAPI({
        url: 'system/gcp/regions',
        method: 'GET',
      });
    };


    this.getSubnets = (region) => {
      return FetchAPI({
        url: `system/gcp/subnets/${region}`,
        method: 'GET',
      });
    };

    this.getInstances = (zone) => {
      return FetchAPI({
        url: `system/gcp/instances/${zone}`,
        method: 'GET',
      });
    };

    //sharedSubnetworks
    this.getSharedVPC = async (project, region) => {
      return FetchAPI({
        url: `system/gcp/sharedVPC/${project}/${region}`,
        method: 'GET'
      })
    }

    this.getRegionsMap = async () => {
      if (this.regions.size > 0) {
        return this.regions;
      }

      let regionList = await this.getRegions();
      regionList.items.map((region) => {
        this.regions.set(region.name, { selfLink: region.selfLink, zones: new Map(region.zones.map(zone => [this.selfLinktoName(zone), zone])) });
      });
      return this.regions;
    };

    this.getNetworksMap = async () => {
      if (this.networks.size > 0) {
        return this.networks;
      }

      let networkList = await this.getNetwork();
      networkList.items.map((network) => {
        this.networks.set(network.name, { selfLink: network.selfLink, subnetworks: new Map(network.subnetworks.map(subnetwork => [this.selfLinktoName(subnetwork), subnetwork])) });
      });
      return this.networks;
    }

    this.getXPNResources = (project) => {
      return FetchAPI({
        url: `system/gcp/xpnresources/${project}`,
        method: 'GET',
      });
    }


    this.getAggregatedInstances = () => {
      return FetchAPI({
        url: "system/gcp/aggregated/instances",
        method: 'GET',
      })
    }

    this.getAggregatedInstancesByProject = (project) => {
      return FetchAPI({
        url: `system/gcp/aggregated/instances/${project}`,
        method: 'GET',
      })
    }

    this.selfLinktoName = (selfLink) => {
      let urlParts = selfLink.split('/');
      return urlParts[urlParts.length - 1];
    }


  }
}

const GCPService = new GCPDataService();

export { GCPService as default, instanceGroupFields };
